import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = [
        'specialismsSelect',
        'specialismsList'
    ];

    connect() {
        this.selectedValues = [];

        // Initialize from existing selected options
        const selectedOptions = Array.from(this.specialismsSelectTarget.selectedOptions);
        this.selectedValues = selectedOptions.map(opt => opt.value);

        if (this.selectedValues.length > 0) {
            this.render();
        }
    }
    
    onChange(e) {
        const selectedValue = e.target.value;

        if (!this.selectedValues.includes(selectedValue)) {
            this.selectedValues.push(selectedValue);
        }

        this.render();
        this.updateFormField();
        this.specialismsSelectTarget.tomselect.clear(true);
    }

    render() {
        this.specialismsListTarget.innerHTML = '';

        const optionMap = new Map(
            Array.from(this.specialismsSelectTarget.options).map(option => [option.value, option.textContent])
        );

        this.selectedValues.forEach(val => {
            const wrapper = document.createElement('span')
            wrapper.className = 'badge badge-lg bg-primary bg-light-blue border-0 pe-2'

            const label = document.createElement('span')
            label.textContent = optionMap.get(val)
            label.className = 'me-2'

            const close = document.createElement('button')
            close.className = 'border-0 m-0 bg-transparent text-primary p-0'
            close.type = 'button'
            close.innerHTML = 'x'

            close.addEventListener('click', () => {
                this.selectedValues = this.selectedValues.filter(v => v !== val)
                this.render()
                this.updateFormField()
            })

            wrapper.appendChild(label)
            wrapper.appendChild(close)
            this.specialismsListTarget.appendChild(wrapper)
        });
    }

    updateFormField() {
        // Update the select field with the current selected values
        Array.from(this.specialismsSelectTarget.options).forEach(option => {
            option.selected = this.selectedValues.includes(option.value);
        });

        // Dispatch change event so LiveComponent knows the field has been updated
        // this.specialismsSelectTarget.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Public method to be called before form submission
    syncToFormField() {
        this.updateFormField();
    }
}
